import { ResponseError } from 'services/api/base';
import { useGetDynamicContentQuery } from 'services/api/home';
import useHandleRequestErrors from 'utils/hooks/useHandleRequestErrors';

export default function useDynamicContent() {
  const {
    data, error, isLoading,
  } = useGetDynamicContentQuery();

  useHandleRequestErrors(error as ResponseError);

  const {
    interval,
    transitionType,
    autoplay,
    images,
  } = data || {
    interval: 5,
    transitionType: 'fade',
    autoplay: true,
    images: [],
  };

  return {
    interval,
    transitionType,
    autoplay,
    images,
    isLoading,
  };
}
